import { restClient } from '../config/restClient'

const endpoint = memberProfileId => `/api/company/v2/member_profiles/${memberProfileId}/unavailable_candidate_notifications`

export const getUnavailableCandidateNotifications = async memberProfileId => {
  const response = await restClient(endpoint(memberProfileId), {
    method: 'GET',
  })
  return response.data
}

export const updateUnavailableCandidateNotifications = async (memberProfileId, params) => {
  const response = await restClient(endpoint(memberProfileId), {
    method: 'PATCH',
    params,
  })
  return response.data
}
